import axios from 'axios';
import { getToken } from './auth'
import { baseURL } from './baseConfig';
import store from '../store'
import { Toast } from 'vant';

var instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'tenant-id': 1
  },
});

instance.defaults.timeout = 10000;
instance.defaults.baseURL = baseURL;
instance.defaults.isCustomHeaders = true; // 是否拦截器重置请求头
instance.interceptors.request.use(
  async (config) => {
    if (config.isCustomHeaders) {
      config.headers = {
        ...config.headers,
      };
    }
    // config.headers['Authorization'] = 'Bearer 517b6d34954842b1b01088d2a46b9479';
    if (getToken()) {
      config.headers['Authorization'] = `Bearer ${getToken()}` // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);

// 中间件 拦截请求-
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    console.error('服务端错误，请稍后重试！');
    return Promise.reject(err);
  },
);

const exceptionHandling = (data) => {
  if (data?.status === 200) {
    return data;
  }
  console.error('服务发生错误');
  return false;
};

const safeRequest = (url, options) => {
  return new Promise((resolve, reject) => {
    instance({
      ...options,
      params: options.params,
      data: options.data,
      url,
      headers: {
        ...options?.header,
      },
    }).then(
      (response) => {
        const res = exceptionHandling(response);
        if (res) {
          if (res.data.code === 0) {
            resolve(res.data.data);
          } else if (res.data.code === 401) {
            reject(res);
            console.error(res.data.msg || '登录过期');
            store.dispatch('userLoginOut');
          } else if (url === '/app-api/therapy/ai/automated-thinking') {
            resolve(res.data);
          } else {
            Toast(res.data.msg || '发生错误');
            reject(res);
          }
        }
      },
      (err) => {
        reject(err);
      },
    );
  });
};

/**
 * get
 * @param url
 * @param opts
 * @returns {Promise}
 */
const get = (url, opts = {}) => {
  return safeRequest(url, opts);
};

/**
 * post
 * @param url
 * @param opts
 * @returns {Promise}
 */
const post = (url, opts = {}) => {
  return safeRequest(url, {
    ...opts,
    method: 'POST',
  });
};

/**
 * put
 * @param url
 * @param opts
 * @returns {Promise}
 */
const put = (url, opts = {}) => {
  return safeRequest(url, {
    ...opts,
    method: 'PUT',
  });
};

/**
 * delete
 * @param url
 * @param opts
 * @returns {Promise}
 */
const reqDelete = (url, opts = {}) => {
  return safeRequest(url, {
    ...opts,
    method: 'DELETE',
  });
};

const jsonp = (url) => {
  return new Promise((resolve) => {
    // 这里的 "jsonCallBack" ，和调用的 jsonp 的 url 中的 callback 值相对应（见粗体字）

    window.jsonCallBack = (result) => {
      resolve(result);
    };

    const JSONP = document.createElement('script');

    JSONP.type = 'text/javascript';

    JSONP.src = url;

    document.getElementsByTagName('head')[0].appendChild(JSONP);

    setTimeout(() => {
      document.getElementsByTagName('head')[0].removeChild(JSONP);
    }, 500);
  });
};

export default {
  instance,
  get,
  post,
  put,
  reqDelete,
  jsonp,
};